import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from './cliente';
import { chaves } from './query';
import type { NovoOrcamento, Orcamento } from './tipos';

/* Orçamento = fotografia de uma análise salva. Guarda entrada e resultado
 * juntos de propósito: o histórico mostra o número como ele era na época,
 * mesmo que os custos da empresa mudem depois. */

export function useOrcamentos() {
  return useQuery({
    queryKey: chaves.orcamentos,
    queryFn: () => api.obter<Orcamento[]>('/orcamentos'),
  });
}

export function useSalvarOrcamento() {
  const clienteQuery = useQueryClient();
  return useMutation({
    // `entradas` e `resultados` são opacos: o histórico é fotografia, não
    // modelo consultado por coluna. Quem salva decide o que registrar.
    mutationFn: (dados: NovoOrcamento) => api.criar<Orcamento>('/orcamentos', dados),
    onSuccess: () => void clienteQuery.invalidateQueries({ queryKey: chaves.orcamentos }),
  });
}
